import validForm from './src/valid-form'
export {
  toggleInvalidClass,
  handleCustomMessages,
  handleCustomMessageDisplay
} from './src/valid-form'
export default validForm
